// extracted by mini-css-extract-plugin
module.exports = {"collapseList":"LegPanel_collapseList__3VRtg","collapseListItem":"LegPanel_collapseListItem__3VZlX"};